import BasicLayout from '@/layout/BasicLayout.vue'

const dncRouter = {
  path: '/dnc',
  component: BasicLayout,
  children: [
    {
      path: '/dnc/my-document',
      component: () => import('../../views/dnc/my-documents/index.vue')
    },
    {
      path: '/dnc/setting',
      component: () => import('../../views/dnc/setting/setting.vue'),
      children: [
        {
          path: '/dnc/setting/resource',
          component: () => import('../../views/dnc/setting/ResourceFields/index'),
        },
        {
          path: '/dnc/setting/document',
          component: () => import('../../views/dnc/setting/DocDirectory/index.vue'),
        },
        {
          path: '/dnc/setting/transport',
          component: () => import('../../views/dnc/setting/TransportDirectory/index.vue'),
        },
        {
          path: '/dnc/setting/processing-program',
          component: () => import('../../views/dnc/setting/ProcessingProgram/index.vue'),
        }
      ]
    },
    {
      path: '/dnc/transport-directory',
      component: () => import('../../views/dnc/transport-directory/index.vue')
    },
    {
      path: '/dnc/station-file',
      component: () => import('../../views/dnc/station-file/index.vue')
    },
    {
      path: '/dnc/resource-pool',
      component: () => import('@/views/dnc/resource-pool/index')
    },
    {
      path: '/dnc/transport',
      component: () => import('../../views/dnc/transport/index.vue')
    },
    {
      path: '/dnc/transmission-source',
      component: () => import('../../views/dnc/transmission-source/index.vue')
    }
    
  ]
}

export default dncRouter
